import { useCustomerFundingNeedsRetrieveSuspense } from "@boundless/bl-api-client/customer/services"
import { zodResolver } from "@hookform/resolvers/zod"
import {
  createFileRoute,
  redirect,
  retainSearchParams,
} from "@tanstack/react-router"
import { useForm } from "react-hook-form"
import { z } from "zod"

import { ButtonBack } from "@/components/buttons/ButtonBack"
import { ButtonNext } from "@/components/buttons/ButtonNext"
import { FundingNeedsForm } from "@/components/funding-needs/FundingNeedsForm"
import { Card, CardTitle } from "@/components/ui/card"
import { Form } from "@/components/ui/form"
import { ApplicationFlowContext } from "@/lib/flows/application"
import { fundingNeedsFormSchema } from "@/lib/schemas"
import { store } from "@/lib/store"

export const Route = createFileRoute(
  "/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/",
)({
  validateSearch: z.object({
    from: z.string().optional(),
  }),
  component: FundingNeedDetail,
  search: {
    middlewares: [retainSearchParams(true)],
  },
  beforeLoad: ({ context: { store } }) => {
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/" })
    }
    return { companyUuid }
  },
})

function FundingNeedDetail() {
  const companyUuid = store.getState().activeCompanyUuid!
  const { fundingNeedsUuid } = Route.useParams()
  const { data: fundingNeed } = useCustomerFundingNeedsRetrieveSuspense(
    companyUuid,
    fundingNeedsUuid,
  )

  const flowActorRef = ApplicationFlowContext.useActorRef()
  const goNext = () => flowActorRef.send({ type: "next" })
  const goBack = () => flowActorRef.send({ type: "back" })

  const form = useForm<z.infer<typeof fundingNeedsFormSchema>>({
    resolver: zodResolver(fundingNeedsFormSchema),
    defaultValues: {
      capitalAmount: fundingNeed.capitalAmount,
      useOfFunds: fundingNeed.useOfFunds,
    },
  })

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <Card className="col-span-1 p-6 lg:col-span-2">
        <CardTitle>Funding Need</CardTitle>
        <Form {...form}>
          <form className="w-full">
            <FundingNeedsForm disabled />
            <div className="mt-8 flex flex-col gap-2 md:flex-row md:justify-end">
              <ButtonBack onClick={goBack} />
              <ButtonNext onClick={goNext} />
            </div>
          </form>
        </Form>
      </Card>
    </div>
  )
}
